





















import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import ReviewDependents from "@/employee/components/onboarding/ReviewDependents.vue";
import ReviewHealthPlan from "@/employee/components/onboarding/ReviewHealthPlan.vue";
import ReviewPersonalDetails from "@/employee/components/onboarding/ReviewPersonalDetails.vue";
import ReviewTerms from "@/employee/components/onboarding/ReviewTerms.vue";
import { NamedOnboarding as OnboardingRouteName } from "@/employee/route-names";
import { useWizardStore } from "@/employee/store/wizard";
import { UserOnboardingSteps } from "@/shared/userOnboarding";

@Component({
  components: {
    Button,
    ReviewDependents,
    ReviewHealthPlan,
    ReviewPersonalDetails,
    ReviewTerms
  }
})
export default class Review extends Vue {
  wizardStore = useWizardStore();

  get shouldShowDependents () {
    if (!this.wizardStore.onboardingWizard || !this.wizardStore.onboardingWizard.statuses) {
      return false;
    }

    return this.wizardStore.onboardingWizard.statuses.some(s => s.step === UserOnboardingSteps.YourFamily);
  }

  onSubmit () {
    this.$emit("complete");
  }

  goBack () {
    const indexOfCurrentStep = this.wizardStore.shownStatuses
      .findIndex(s => s.step === UserOnboardingSteps.VerifyIdentity);

    if (indexOfCurrentStep < 1) {
      return;
    }

    const previousStep = this.wizardStore.shownStatuses[indexOfCurrentStep - 1];

    this.goToStep(previousStep.stepKey);
  }

  goToStep (stepKey: string) {
    this.$router.push({ name: OnboardingRouteName, params: { stepKey } });
  }
}
